import { createSelector } from '@reduxjs/toolkit';
import { StorageState } from '../../../../reducers';

const sliceSelector = (state: StorageState) => state.users.users.list;

export const accessUsersListSelector = () => createSelector(sliceSelector, state => state.list);
export const accessUsersTotalSelector = () => createSelector(sliceSelector, state => state.total);
export const accessUsersLoading = () => createSelector(sliceSelector, state => state.isLoading);
export const accessUsersLoaded = () => createSelector(sliceSelector, state => state.isLoaded);
